export const colorByDepartmentId: Record<string, string> = {
  E10002: "red",
  E10003: "green",
  E10004: "volcano",
  E10005: "magenta",
  E10006: "purple",
  E10007: "cyan",
  E10008: "lime",
  E10009: "orange",
  E10010: "gold",
};

export const capitalizeFirstLetter = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
